<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <PageHead label='系统参数设置'></PageHead>
      <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
        <!--begin: Search Form -->
        <div class="m-form m-form--label-align-right">
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 80px;text-align:right;">参数类型：</label>
              </div>
              <div class="m-form__control">
                <el-select v-model="condition.dictid" filterable>
                  <el-option v-for="item in Dict" :key="item.DictID" :label="item.DictName" :value="item.DictID"></el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>
        <div style="clear: both;"></div>
        <div class="m--margin-top-10 m--margin-bottom-10" style="width: 100%;text-align: center;float: initial;">
          <SearchButton :url="searUrl" ref="btnSearch"></SearchButton>
          <AddButton url="/system/dict/add"></AddButton>
        </div>
        <!--end: Search Form -->
      </div>
      <div class="m-portlet__body">
        <!--begin: Datatable -->
        <el-table :data="tableData" stripe style="width: 100%" size="medium">
          <el-table-column prop="DictRemark" label="数据类型">
          </el-table-column>
          <el-table-column prop="DictItemName" label="参数名称">
          </el-table-column>
          <el-table-column prop="DictItemValue" label="参数值">
          </el-table-column>
          <el-table-column prop="DictItemType" label="参数类型">
          </el-table-column>
          <el-table-column prop="OrderIndex" label="显示顺序">
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="100">
            <template slot-scope="scope">
              <el-button @click="Edit(scope.row)" type="text" size="medium">修改</el-button>
              <el-button @click="Delete(scope.row)" type="text" size="medium">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!--end: Datatable -->
        <!--begin: Pager -->
        <div style="margin-top: 10px;text-align: center;" v-if="this.condition.recordCount > 0">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="condition.currentPage"
            :page-sizes="[10, 20, 30, 40]" :page-size="condition.pageSize" layout="total, sizes, prev, pager, next, jumper"
            :total="condition.recordCount">
          </el-pagination>
        </div>
        <!--end: Pager -->
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'DictList',
    data() {
      return {
        Dict: [{}],
        condition: {
          dictid: '',
          token: '',
          currentPage: 1,
          pageSize: 10,
          recordCount: 0,
          firstSearch: true
        },
        tableData: null,
        searUrl: this.$utils.Url.system + '/systemapi/dictitem/list'
      }
    },
    methods: {
      // 调整每页显示数
      handleCurrentChange: function(val) {
        this.condition.firstSearch = false
        this.condition.currentPage = val
        this.$refs.btnSearch.Search()
      },
      // 分页操作
      handleSizeChange: function(val) {
        this.condition.firstSearch = false
        this.condition.pageSize = val
        this.condition.currentPage = 1
        this.$refs.btnSearch.Search()
      },
      Edit: function(row) {
        this.$router.push({
          name: 'DictEdit',
          params: {
            id: row.DictItemID,
            dictname: row.DictName
          }
        })
      },
      Delete: function(row) {
        var args = {
          id: row.DictItemID,
          token: this.condition.token
        }
        this.$utils.Delete(this.$utils.Url.system + '/systemapi/dictitem/delete', args, row.DictItemName, this.$refs.btnSearch
          .Search)
      }
      // 此处可以重写数据绑定方法
      // DataList: function () {
      //   console.log(this.condition)
      //   this.$http.post('/systemapi/dictitem/list', this.condition)
      //     .then(res => {
      //       if (res.data.Code === 0) {
      //         this.tableData = res.data.Data
      //         this.condition.recordCount = res.data.Pager.RecordCount
      //       } else {
      //         alert(res.data.Msg + '，' + res.data.Error)
      //       }
      //     })
      //     .catch(err => {
      //       console.log(err)
      //       alert('请求失败')
      //     })
      // }
    },
    mounted: function() {
      this.condition.token = sessionStorage.getItem('token')
      this.condition.dictid = 3
      var that = this
      var args = {
        token: this.condition.token
      }
      this.$utils.HttpPost(this.$utils.Url.system + '/systemapi/dictitem/dictlist', args, function(d) {
        that.Dict = d.Data
      }, null, null)
      this.$refs.btnSearch.Search()
    }
  }
</script>

<style>
</style>
